import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { WarningTextFieldComponent } from '../../app/components/warning-text-field/warning-text-field.component';

@Component({
  selector: 'reza-landing-page',
  standalone: true,
  imports: [CommonModule, RouterModule, WarningTextFieldComponent],
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.scss',
})
export class LandingPageComponent {}
